export default __webpack_public_path__ + "static/media/SeminarioIes2026_LauraArroyo.b79e16bd.jpg";